import { jsxs, Fragment } from 'react/jsx-runtime';
import { useMemo, isValidElement, cloneElement } from 'react';
import { tv } from 'tailwind-variants';
import { cn } from '../../../utils/cn.esm.js';

const linkContentStyles = tv({
    slots: {
        icon: "",
    },
    variants: {
        size: {
            md: {
                icon: "iris:w-(--comp-size-icon-link-md)",
            },
            sm: {
                icon: "iris:w-(--comp-size-icon-link-sm)",
            },
            xs: {
                icon: `iris:w-(--comp-size-icon-link-xs)`,
            },
            xxs: {
                icon: `iris:w-(--comp-size-icon-link-xxs)`,
            },
        },
        iconSize: {
            md: {
                icon: `
          iris:h-(--comp-size-icon-link-sm)
          iris:w-(--comp-size-icon-link-sm)
        `,
            },
            lg: {
                icon: `
          iris:h-(--comp-size-icon-link-lg)
          iris:w-(--comp-size-icon-link-lg)
        `,
            },
        },
    },
    compoundVariants: [
        {
            size: "md",
            iconSize: "md",
            class: {
                icon: `
          iris:h-(--comp-size-icon-link-sm)
          iris:w-(--comp-size-icon-link-sm)
        `,
            },
        },
        {
            size: "md",
            iconSize: "lg",
            class: {
                icon: `
          iris:h-(--comp-size-icon-link-lg)
          iris:w-(--comp-size-icon-link-lg)
        `,
            },
        },
        {
            size: "sm",
            iconSize: "md",
            class: {
                icon: `
          iris:h-(--comp-size-icon-link-sm)
          iris:w-(--comp-size-icon-link-sm)
        `,
            },
        },
        {
            size: "sm",
            iconSize: "lg",
            class: {
                icon: `
          iris:h-(--comp-size-icon-link-lg)
          iris:w-(--comp-size-icon-link-lg)
        `,
            },
        },
        {
            size: "xs",
            iconSize: "md",
            class: {
                icon: `
          iris:h-(--comp-size-icon-link-xs)
          iris:w-(--comp-size-icon-link-xs)
        `,
            },
        },
        {
            size: "xs",
            iconSize: "lg",
            class: {
                icon: `
          iris:h-(--comp-size-icon-link-md)
          iris:w-(--comp-size-icon-link-md)
        `,
            },
        },
        {
            size: "xxs",
            iconSize: "md",
            class: {
                icon: `
          iris:h-(--comp-size-icon-link-xxs)
          iris:w-(--comp-size-icon-link-xxs)
        `,
            },
        },
        {
            size: "xxs",
            iconSize: "lg",
            class: {
                icon: `
          iris:h-(--comp-size-icon-link-xs)
          iris:w-(--comp-size-icon-link-xs)
        `,
            },
        },
    ],
});

/**
 * LinkContent component handles rendering of icon and children for Link component
 */
const LinkContent = ({ icon, size, iconSize, children, }) => {
    const classes = useMemo(() => linkContentStyles({ size, iconSize }), [size, iconSize]);
    return (jsxs(Fragment, { children: [isValidElement(icon) &&
                cloneElement(icon, {
                    className: cn(classes.icon(), icon.props.className),
                }), children] }));
};
LinkContent.displayName = "LinkContent";

export { LinkContent };
